// extracted by mini-css-extract-plugin
export default {"simulateNow":"styles_simulateNow__4cb8B","colLeft":"styles_colLeft__dcCr1"};